export { PlansComponent } from './plans.component'; 